
import { browser } from '../../../react/features/base/lib-meet-hour';

/**
 * Returns true if Meet Hour is running in too old meet-hour-electron app and false otherwise.
 *
 * @returns {boolean} - True if Meet Hour is running in too old meet-hour-electron app and false otherwise.
 */
export function isOldMeetHourElectronApp() {
    if (!browser.isElectron()) {
        return false;
    }

    const match = navigator.userAgent.match(/(MeetHour)\s*\/\s*((\d+)\.[^\s]*)/);

    if (!Array.isArray(match) || match.length < 3) {
        return false;
    }

    const majorVersion = Number(match[3]);

    if (isNaN(majorVersion) || majorVersion >= 2) {
        return false;
    }

    return true;
}
